import numberToWords from "@iyansr/angka-terbilang";
import dayjs from "dayjs";
import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import Api from "../../../../../Services/Api";
import { GenericSequenceType, HttpStatus, Status } from "../../../../common/Constants";
import { flattenFormGroupObject, mapToObjectDDL } from "../../../../common/mapper";
import { downloadPdf, printPDF } from "../../common/downloadUtils";
import * as R from "ramda";
import { contructQueryParam, fetchDataAsync, isNotNilAndEmpty } from "../../../../../Services/Utils";
import M from "moment/moment";
import { connect } from "react-redux";
import DocumentReference from "../../common/documentReference";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import PaymentPrintPreview from "../../common/paymentPrintPreview";

class TabBKMDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kasOptions: [],
            documentOptions: [],
            categoryOption: [],
            relationOptions: [],
            jenisTransaksiOptions: [],
            data: null,
            loading: false,
            searchDocVisible: false,
            alertVisible: false,
            alertMessage: null,
            alertAction: null,
            cetak: false,
            previewVisible: false,
            PDF: null,
            updatePrintCount: null
        };
    }

    async componentDidMount() {
        this.fetchInitialData()
        this.fetchDataDetailCoaPayment()
    }

    fetchInitialData = async () => {
        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const kasOptions = [];
        const documentOptions = [];
        const relationOptions = [];
        const categoryOption = [];

        if (this.props.isEditable || this.props.action == "editDDL") {
            const responses = await Promise.all([
                Api.create("NAGAMAS_MASTER_DATA").getAllMasterKas({
                    paramFilters: {
                        status: Status.ACTIVE,
                        kodeCabang: this.props.kodeCabang,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "DOCUMENT_TYPE",
                        status: Status.ACTIVE,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "RELATION_TYPE",
                        status: Status.ACTIVE,
                    },
                }),
                Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                    paramFilters: {
                        bizparCategory: "PAYMENT_SPECIAL_CATEGORY",
                        status: Status.ACTIVE,
                    },
                }),
            ]);

            responses.forEach((response, idx) => {
                if (idx === 0) {
                    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                        kasOptions.push(
                            ...response.data.data.map((d) => mapToObjectDDL(`${d.kodeKas} - ${d.name}`, d.kodeKas))
                        );
                    }
                } else if (idx === 1) {
                    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                        documentOptions.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                } else if (idx === 2) {
                    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                        relationOptions.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                } else {
                    if (response.data.status === HttpStatus.SUCCESS) {
                        categoryOption.push(
                            ...response.data.data.map((d) => mapToObjectDDL(d.value, d.key))
                        );
                    }
                }
            });
        }else{
            const responseBKMMasterKas = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterKas({
                paramFilters: {
                    status: Status.ACTIVE,
                    kodeCabang: this.props.kodeCabang,
                },
            })
            if (responseBKMMasterKas.ok && responseBKMMasterKas.data.status === HttpStatus.SUCCESS) {
                kasOptions.push(
                    ...responseBKMMasterKas.data.data.map((d) => mapToObjectDDL(`${d.kodeKas} - ${d.name}`, d.kodeKas))
                );
            }
        }

        if (isNotNilAndEmpty(this.props.id)) {
            const response = await Api.create("NAGAMAS_TRANSACTION").getBKMDetail(this.props.id);
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                const data = response.data.data;
                const kodeKasValue = data.kodeKas
                    ? mapToObjectDDL(data.kodeKas.name, data.kodeKas.kodeKas)
                    : data.kodeKas;
                const jenisRelasiValue = data.jenisRelasi
                    ? mapToObjectDDL(data.jenisRelasi.value, data.jenisRelasi.key)
                    : data.jenisRelasi;
                const dataSpecialCategoryValue = data.dataSpecialCategory
                    ? mapToObjectDDL(data.dataSpecialCategory.value, data.dataSpecialCategory.key)
                    : data.dataSpecialCategory;
                const jenisDokumen = data.jenisDokumen
                    ? mapToObjectDDL(data.jenisDokumen.value, data.jenisDokumen.key)
                    : data.jenisDokumen;
                const jenisTransaksi = data.dataMasterCOA
                    ? mapToObjectDDL(data.dataMasterCOA.transactionType, data.dataMasterCOA.id)
                    : data.dataMasterCOA;

                this.props.setValue("kodeKas", kodeKasValue);
                this.props.setValue("namaTerimaDari", data.namaTerimaDari);
                this.props.setValue("nilaiRupiah", data?.nilaiRupiah);
                let words = null;
                if (!R.isNil(data.nilaiRupiah)) {
                    const numberWords = numberToWords(parseInt(data.nilaiRupiah));
                    words = this.capitalizeWords(numberWords) + " Rupiah";
                    this.props.setValue("terbilang", words);
                }
                this.props.setValue("jenisRelasi", jenisRelasiValue);
                this.props.setValue("dataSpecialCategory", dataSpecialCategoryValue);
                this.props.setValue("gunaMembayar", data.gunaMembayar);
                this.props.setValue("keterangan", data.keterangan);
                this.props.setValue("jenisTransaksi", jenisTransaksi);
                this.props.setValue("jenisDokumen", jenisDokumen);
                this.props.setValue("realisasi", data.realisasi);

                this.setState((prevValue) => ({
                    ...prevValue,
                    data: {
                        ...data,
                        jenisRelasi: jenisRelasiValue,
                        kodeKas: kodeKasValue,
                        dataSpecialCategory: dataSpecialCategoryValue,
                        terbilang: words,
                        sourcePayment: this.props.sourcePayment || data.sourcePayment || null,
                        countCetakan: data.countCetakan || 0
                    },
                    kasOptions,
                    documentOptions,
                    relationOptions,
                    categoryOption
                }));
            }
        } else {
            let paymentCashId = await this.fetchDataGenerateSeq({
                seqType: GenericSequenceType.PAYMENT_CASH_IN,
                nosDealerCode: this.props.kodeCabang,
                transactionType: GenericSequenceType.PAYMENT_CASH_IN,
            })

            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    paymentCashId: paymentCashId,
                    tanggalPayment: M(new Date()).format("DD-MM-YYYY"),
                    statusCetakan: "BELUM_DICETAK",
                    countCetakan: 0,
                    author: this.props.user?.user?.username,
                    sourcePayment: this.props.sourcePayment || null,
                },
                kasOptions,
                documentOptions,
                relationOptions,
                categoryOption
            }))
        }

        this.setState((prevValue) => ({ ...prevValue, loading: false }));
    }

    fetchDataDetailCoaPayment = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findDetailCoaPayment,
            menuName: "Finance - Transaksi Cash",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.kodeCabang, category: 'TRX_IN'}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                 jenisTransaksiOptions: res.data.data.map((item) => mapToObjectDDL(item.transactionType, item.id)),
            }));
        }
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleSave = async () => {
        if (!this.props.validate()) {
            return;
        }

        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const data = this.state.data;
        const controls = flattenFormGroupObject(this.props.controls);
        console.log("data", data);
        console.log("controls", controls);
        const request = {
            kodeCabang: this.props.kodeCabang,
            paymentId: this.props.id,
            tanggalPayment: data?.tanggalPayment,
            documentRef1Date: data?.tanggalDocumentRef1,
            documentRef1: data?.documentRef1,
            documentRef2Date: data?.tanggalDocumentRef2,
            paymentRealizationDate: controls?.realisasi === true ? dayjs(new Date()).format("DD-MM-YYYY") : null,
            documentRef2: data?.documentRef2,
            cashCode: controls?.kodeKas?.value,
            transactionPersonName: controls?.namaTerimaDari,
            paymentRelationType: controls?.jenisRelasi?.value,
            specialCategory: controls?.dataSpecialCategory?.value||null,
            paymentAmount: parseInt(controls?.nilaiRupiah) ?? 0,
            paymentSpellingAmount: controls?.terbilang,
            paymentPurpose: controls?.gunaMembayar,
            note: controls?.keterangan,
            documentType: controls?.jenisDokumen?.value,
            transactionType: controls?.jenisTransaksi?.value,
            printCount: parseInt(data?.countCetakan) ?? 0,
            paymentStatus: controls?.realisasi === true ? 'REALISASI' : this.props.paymentStatus,
            paymentType: "IN",
            printStatus: data?.statusCetakan,
            author: data?.author,
            sourcePayment: data?.sourcePayment
        };

        await Api.create("NAGAMAS_TRANSACTION").submitPaymentCash(request);
        this.setState((prevValue) => ({ ...prevValue, loading: false }));
        this.props.onClickClose(null);
    };

    handlePreview = async (action) => {
        if (R.equals(action, "generate")) {
            const data = this.state.data;
            const request = {
                kodeCabang: this.props.kodeCabang,
                tanggalPayment: dayjs(new Date()).format("DD-MM-YYYY"),
                paymentCashId: data?.paymentCashId,
                tanggalDocumentRef2: data?.tanggalDocumentRef2,
                documentRef2: data?.documentRef2,
                tanggalDocumentRef1: data?.tanggalDocumentRef1,
                documentRef1: data?.documentRef1,
                terbilang: data?.terbilang,
                namaTerimaDari: data?.namaTerimaDari,
                gunaMembayar: data?.gunaMembayar,
                keterangan: data?.keterangan,
                nilaiRupiah: parseInt(data?.nilaiRupiah) ?? 0,
                countCetakan: parseInt(data?.countCetakan) ?? 0,
            };

            if (this.props.isEditable || this.props.action == "editDDL") {
                const controls = flattenFormGroupObject(this.props.controls);
                request.nilaiRupiah = parseInt(controls?.nilaiRupiah) ?? 0;
                request.terbilang = controls?.terbilang;
                request.gunaMembayar = controls?.gunaMembayar;
                request.keterangan = controls?.keterangan;
                request.namaTerimaDari = controls?.namaTerimaDari;
            }

            this.setState((prevValue) => ({ ...prevValue, loading: true }));
            const response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").printBKM,
                menuName: "Transaksi Cash - BKM",
                setError: this.props.setError,
                args: request,
            });
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    PDF: URL.createObjectURL(response.data),
                    previewVisible: !prevValue.previewVisible,
                    updatePrintCount: null
                }));
            }

            this.setState((prevValue) => ({ ...prevValue, loading: false }));
        }

        if (R.equals(action, "close")) {
            this.setState((prevValue) => ({
                ...prevValue,
                previewVisible: !prevValue.previewVisible,
                updatePrintCount: null
            }));
        }
    };

    updatePrintCountProcess = async (id) => {
        await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").updatePrintCountAndStatusCash,
          menuName: "Transaksi Cash - BKK",
          setError: this.props.setError,
          args: contructQueryParam({ paymentId: id }),
        });
        this.fetchInitialData();
    }

    handlePrint = async () => {
        const data = this.state.data;
        const request = {
            kodeCabang: this.props.kodeCabang,
            tanggalPayment: dayjs(new Date()).format("DD-MM-YYYY"),
            paymentCashId: data?.paymentCashId,
            tanggalDocumentRef2: data?.tanggalDocumentRef2,
            documentRef2: data?.documentRef2,
            tanggalDocumentRef1: data?.tanggalDocumentRef1,
            documentRef1: data?.documentRef1,
            terbilang: data?.terbilang,
            namaTerimaDari: data?.namaTerimaDari,
            gunaMembayar: data?.gunaMembayar,
            keterangan: data?.keterangan,
            nilaiRupiah: parseInt(data?.nilaiRupiah) ?? 0,
            countCetakan: parseInt(data?.countCetakan) ?? 0,
        };

        if (this.props.isEditable || this.props.action == "editDDL") {
            const controls = flattenFormGroupObject(this.props.controls);
            request.nilaiRupiah = parseInt(controls?.nilaiRupiah) ?? 0;
            request.terbilang = controls?.terbilang;
            request.gunaMembayar = controls?.gunaMembayar;
            request.keterangan = controls?.keterangan;
            request.namaTerimaDari = controls?.namaTerimaDari;
        }

        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT").printBKM,
            menuName: "Transaksi Cash - BKM",
            setError: this.props.setError,
            args: request,
        });
        if (response.ok) {
            printPDF(response.data)
            this.updatePrintCountProcess(data?.paymentId)
        }
        this.setState((prevValue) => ({ ...prevValue, loading: false, alertVisible: false, cetak: true }));
    };

    handleSearchDocVisibility = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            selectedDoc: value,
            searchDocVisible: !prevState.searchDocVisible
        }))
    }

    handleClearDoc = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                documentRef1: R.equals(value, "documentRef1") ? "" : prevState.data.documentRef1,
                tanggalDocumentRef1: R.equals(value, "documentRef1") ? null : prevState.data.tanggalDocumentRef1,
                documentRef2: R.equals(value, "documentRef2") ? "" : prevState.data.documentRef2,
                tanggalDocumentRef2: R.equals(value, "documentRef2") ? null : prevState.data.tanggalDocumentRef2
            }
        }));
    }

    handleSelectDocumentReference = (data, sourceDocument) => {
        const { selectedDoc } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                documentRef1: R.equals(selectedDoc, "documentRef1") ? data[`nomor${sourceDocument}`] : prevState.data.documentRef1,
                tanggalDocumentRef1: R.equals(selectedDoc, "documentRef1") ? data[`tanggal${sourceDocument}`] : prevState.data.tanggalDocumentRef1,
                documentRef2: R.equals(selectedDoc, "documentRef2") ? data[`nomor${sourceDocument}`] : prevState.data.documentRef2,
                tanggalDocumentRef2: R.equals(selectedDoc, "documentRef2") ? data[`tanggal${sourceDocument}`] : prevState.data.tanggalDocumentRef2
            }
        }))

        this.handleSearchDocVisibility();
    }

    handleAlertVisibility = (text, action) => {
        this.setState((prevState) => ({
            ...prevState,
            alertVisible: !prevState.alertVisible,
            alertMessage: text,
            alertAction: action
        }))
    }

    handleConfirmSave = (action) => {
        if (!this.props.validate()) {
            return;
        }

        let message = `Perubahan data BKM dengan \n no BKM: ${this.state.data?.paymentCashId} 
            \n akan dilakukan. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleCreateApprovalPrint = async () =>{
        const userId = localStorage.getItem("userId");

        this.setState({ loading: true })

        const payload = {
          trxId: this.state.data?.paymentCashId,
          kodeCabang: this.props.kodeCabang,
          idUserPemohon: userId,
          module: "TRANSAKSI_CASH",
          listBarcode: null
        };

        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
            menuName: "Transaksi Cash - BKM",
            setError: this.props.setError,
            args: payload,
        })
        this.setState({ loading: false })
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.handleAlertVisibility()
            this.props.onClickClose(null);
        }
    }

    handleCheckPrint = async () => {
        this.setState({ loading: true });
        const userId = localStorage.getItem("userId");
        
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkApprovalPrintTransaction,
            menuName: "Transaksi Cash - BKK",
            setError: this.props.setError,
            args: {
              trxId: this.state.data?.paymentCashId,
              kodeCabang: this.props.kodeCabang,
              idUserPemohon: userId,
              module: "TRANSAKSI_CASH",
              listBarcode: null
            }
        })

        this.setState({ loading: false });
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            const { trxIdToPrint, idRequest } = res.data.data;
            if(trxIdToPrint && !idRequest){
                this.handlePrint()
                return
            }else if(!trxIdToPrint && !idRequest){
                this.handleConfirmPrint('approval')
                return;
            }else{
                const message = `Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: ${this.state.data?.paymentCashId} \ndilakukan keputusan APPROVE/REJECT`
                this.handleAlertVisibility(message, 'in-approval');
            }
        }
    }

    handleConfirmPrint = (action) => {
        let message = `Cetak ulang BKM dengan \n no BKM: ${this.state.data?.paymentCashId} 
            \n membutuhkan approval. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleConfirmCancel = (action) => {
        let message = `Pembatalan BKM dengan \n no BKM: ${this.state.data?.paymentCashId} 
            \n akan dilakukan. Apakah anda yakin?`;
        this.handleAlertVisibility(message, action);
    }

    handleCancel = async () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
        const request = contructQueryParam({ paymentCashId: this.state.data?.paymentCashId });
        await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").cancelPaymentCash,
            setError: this.props.setError,
            menuName: "Transaksi Cash - BKM",
            args: request,
        });
        this.setState((prevValue) => ({ ...prevValue, loading: false }));
        this.props.onClickClose(null);
    }

    capitalizeWords = (str) => str.replace(/\b\w/g, char => char.toUpperCase());

    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.title}
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose(this.state.cetak ? null : "")}
                    content={
                        <ModalContainer>
                            <div id="form-1" className="grid grid-3x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleDate
                                        id="select_date_tanggal_bkm"
                                        name="tanggalBKM"
                                        label="Tanggal BKM"
                                        disabled
                                        date={new Date()}
                                    />
                                    <SimpleInput
                                        id="input_text_no_bkm"
                                        name="noBKM"
                                        label="No. BKM"
                                        value={this.state.data?.paymentCashId}
                                        readOnly
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleDate
                                        id="select_date_tanggal_doc_ref1"
                                        name="tanggalDocRef1"
                                        label="Tanggal Dokumen Ref 1"
                                        date={this.state.data?.tanggalDocumentRef1}
                                        disabled
                                    />
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <SimpleInput
                                            id="input_text_no_doc_ref1"
                                            name="noDocRef1"
                                            label="No. Dokumen Ref 1"
                                            value={this.state.data?.documentRef1}
                                            readOnly
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                                            onClick={() => this.handleSearchDocVisibility("documentRef1")}
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<span style={{ fontSize: "16px", fontWeight: "bold" }}>X</span>}
                                            onClick={() => this.handleClearDoc("documentRef1")}
                                        />
                                    </div>
                                </div>
                                <div id="grid-3">
                                    <SimpleDate
                                        id="select_date_tanggal_doc_ref2"
                                        name="tanggalDocRef2"
                                        label="Tanggal Dokumen Ref 2"
                                        date={this.state.data?.tanggalDocumentRef2}
                                        disabled
                                    />
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <SimpleInput
                                            id="input_text_no_doc_ref2"
                                            name="noDocRef2"
                                            label="No. Dokumen Ref 2"
                                            value={this.state.data?.documentRef2}
                                            readOnly
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                                            onClick={() => this.handleSearchDocVisibility("documentRef2")}
                                        />
                                        <SimpleButton
                                            disabled={!this.props.isEditable}
                                            category="action_button"
                                            icon={<span style={{ fontSize: "16px", fontWeight: "bold" }}>X</span>}
                                            onClick={() => this.handleClearDoc("documentRef2")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="spacer" />
                            <div id="form-2">
                                <div
                                    className="grid grid-2x grid-mobile-none gap-15px"
                                >
                                    <div id="grid-1">
                                        <SimpleDDL
                                            id="select_options_kode_bkas"
                                            name="kodeKas"
                                            label="Kode Kas"
                                            box="search"
                                            options={this.state.kasOptions}
                                            readOnly={!this.props.isEditable}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.kodeKas}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.kodeKas.value
                                                    : this.state.data?.kodeKas
                                            }
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                        <SimpleInput
                                            id="input_text_nama_terima_dari"
                                            name="namaTerimaDari"
                                            label="Terima Dari"
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.namaTerimaDari}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.namaTerimaDari.value
                                                    : this.state.data?.namaTerimaDari
                                            }
                                            readOnly={!this.props.isEditable}
                                            onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                        />
                                        <SimpleInput
                                            id="input_text_nilai_rupiah"
                                            name="nilaiRupiah"
                                            label="Nilai Rupiah"
                                            box="number"
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.nilaiRupiah.value
                                                    : this.state.data?.nilaiRupiah
                                            }
                                            readOnly={
                                              !this.props.isEditable ||
                                              (
                                                this.state.data?.sourcePayment !== 'PAYMENT' &&
                                                this.state.data?.sourcePayment !== 'STOCK_OPNAME'
                                              )
                                            }
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.nilaiRupiah}
                                            onValueChange={({ value }) => {
                                                this.props.setValue("nilaiRupiah", value);
                                                const numberWords = numberToWords(parseInt(value));
                                                const words = this.capitalizeWords(numberWords) + " Rupiah";
                                                this.props.setValue("terbilang", words);
                                            }}
                                        />
                                    </div>
                                    <div id="grid-2">
                                        <SimpleDDL
                                            id="select_options_jenis_relasi"
                                            name="jenisRelasi"
                                            label="Jenis Relasi"
                                            box="search"
                                            readOnly={!this.props.isEditable}
                                            options={this.state.relationOptions}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisRelasi}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls.jenisRelasi.value
                                                    : this.state.data?.jenisRelasi
                                            }
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                        <SimpleDDL
                                            id="select_options_data_special_category"
                                            name="dataSpecialCategory"
                                            label="Kategori Khusus"
                                            box="search"
                                            // readOnly={!this.props.isEditable || this.props.paymentStatus === "REALISASI"}
                                            readOnly={(
                                              (!this.props.isEditable && this.props.action !== "editDDL") 
                                            )}
                                            options={this.state.categoryOption}
                                            value={
                                                this.props.isEditable
                                                    ? this.props.controls?.dataSpecialCategory?.value
                                                    : this.state.data?.dataSpecialCategory
                                            }
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                    </div>
                                </div>
                                <SimpleTextArea
                                    id="input_text_terbilang"
                                    name="terbilang"
                                    label="Terbilang"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.terbilang.value
                                            : this.state.data?.terbilang
                                    }
                                    readOnly
                                />
                                <SimpleTextArea
                                    id="input_text_guna_membayar"
                                    name="gunaMembayar"
                                    label="Guna Membayar"
                                    typeInputCase="normal"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.gunaMembayar.value
                                            : this.state.data?.gunaMembayar
                                    }
                                    mandatory={this.props.isEditable}
                                    errorMessage={this.props.errors.gunaMembayar}
                                    readOnly={!this.props.isEditable || this.state.data?.sourcePayment == 'STOCK_OPNAME'}
                                    onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                />
                                <SimpleTextArea
                                    id="input_text_keterangan"
                                    name="keterangan"
                                    label="Keterangan"
                                    typeInputCase="normal"
                                    value={
                                        this.props.isEditable
                                            ? this.props.controls.keterangan.value
                                            : this.state.data?.keterangan
                                    }
                                    mandatory={this.props.isEditable}
                                    errorMessage={this.props.errors.keterangan}
                                    readOnly={!this.props.isEditable || this.state.data?.sourcePayment == 'STOCK_OPNAME'}
                                    onChange={({ target }) => this.props.setValue(target.name, target.value)}
                                />
                            </div>
                            <div className="spacer" />
                            <div id="form-2">
                                <div className="grid grid-3x grid-mobile-none gap-15px">
                                    <div id="grid-1">
                                        <SimpleDDL
                                            id="select_options_jenis_transaksi"
                                            name="jenisTransaksi"
                                            label="Jenis Transaksi (COA)"
                                            box="search"
                                            readOnly={(!this.props.isEditable && this.props.action !== "editDDL")}
                                            value={this.props.controls.jenisTransaksi.value}
                                            options={this.state.jenisTransaksiOptions}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisTransaksi}
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                        <SimpleInput
                                            id="input_text_count_cetakan"
                                            name="countCetakan"
                                            label="Count Cetakan"
                                            box="onlyNumber"
                                            value={this.state.data?.countCetakan}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="input_text_status_cetakan"
                                            name="statusCetakan"
                                            label="Status Cetakan"
                                            value={this.state.data?.statusCetakan}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="input_text_author"
                                            name="author"
                                            label="Author"
                                            value={this.state.data?.author}
                                            readOnly
                                        />
                                    </div>
                                    <div id="grid-2">
                                        <SimpleDDL
                                            id="select_options_jenis_dokumen"
                                            name="jenisDokumen"
                                            label="Jenis Dokumen"
                                            box="search"
                                            readOnly={!this.props.isEditable}
                                            options={this.state.documentOptions}
                                            value={this.props.controls.jenisDokumen.value}
                                            mandatory={this.props.isEditable}
                                            errorMessage={this.props.errors.jenisDokumen}
                                            onChange={(value, { name }) => this.props.setValue(name, value)}
                                        />
                                    </div>
                                    <div id="grid-3">
                                        <SimpleCheckBox
                                            id="realisasi"
                                            name="realisasi"
                                            label="Realisasi"
                                            styles={{ marginTop: "30px" }}
                                            checked={this.props.controls.realisasi.value}
                                            disabled={this.props.action !== "realisasi" && !this.props.isEditable}
                                            onChange={({ target }) => {
                                                this.props.setValue(target.name, target.checked);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                                {this.props.action === "batal" ? (
                                    <SimpleButton text="Batal" onClick={() => this.handleConfirmCancel("cancel")} />
                                ) : (
                                    <>
                                        {
                                            !this.props.isPreview && (
                                                <>
                                                    <SimpleButton
                                                        text="Preview"
                                                        onClick={() => this.handlePreview("generate")}
                                                    />
                                                    <SimpleButton
                                                        text="Cetak"
                                                        onClick={() => this.handleCheckPrint("cetak")}
                                                    />
                                                </>
                                            )
                                        }
                                        {(this.props.isEditable || this.props.action === "realisasi" || this.props.action === "editDDL") && (
                                            <SimpleButton
                                                text="Simpan"
                                                onClick={() => this.handleConfirmSave("save")}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </ModalContainer>
                    }
                />
                {this.state.previewVisible && (
                    <PaymentPrintPreview
                        {...this.props}
                        title="Preview Print BKM"
                        PDF={this.state.PDF}
                        orientation="potrait"
                        paper="A4"
                        visible={this.state.previewVisible}
                        updatePrintCount={this.state.updatePrintCount}
                        onClickClose={() => this.handlePreview("close")}
                    />
                )}
                {this.state.searchDocVisible && (
                    <DocumentReference
                        kodeCabang={this.props.kodeCabang}
                        onClickSelectDocumentReference={this.handleSelectDocumentReference}
                        visible={this.state.searchDocVisible}
                        onClickClose={this.handleSearchDocVisibility}
                    />
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        visible={this.state.alertVisible}
                        text={this.state.alertAction === "in-approval" ? "Ok" : "Batal"}
                        onClickClose={this.handleAlertVisibility}
                        content={
                            <div>
                                <p>{this.state.alertMessage}</p>
                                <FlexView hAlignContent="center">
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="Batal"
                                        onClick={() => this.handleAlertVisibility()}
                                    />
                                    {this.state.alertAction === "approval" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleCreateApprovalPrint()}
                                        />
                                    )}
                                    {this.state.alertAction === "save" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleSave()}
                                        />
                                    )}
                                    {this.state.alertAction === "cetak" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handlePrint()}
                                        />
                                    )}
                                    {this.state.alertAction === "cancel" && (
                                        <SimpleButton
                                            className="margin-top-15px"
                                            text="Iya"
                                            onClick={() => this.handleCancel()}
                                        />
                                    )}
                                </FlexView>
                            </div>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormGroup(TabBKMDetail));
